module.exports = __webpack_public_path__ + "static/media/wealth.786dc7d7.svg";